// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import config from '@/config';
import store from '@/store';
import i18n from '@/locale';
import mixin from '@/libs/mixin';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/pulic.less';

Vue.config.productionTip = false;
/**
 * @description 全局注册应用配置
 */
Vue.prototype.$config = config;
Vue.mixin(mixin);
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value),
});
function changeFontSize() {
  var offWidth = document.documentElement.clientWidth / 30; //宽度/30表示1rem取得的px
  document.getElementsByTagName('html')[0].style.fontSize = offWidth + 'px'; //把rem的值复制给顶级标签html的font-size
}
window.onresize = function() {
  changeFontSize();
};
changeFontSize();

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: {
    App,
  },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js